<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
      label-position="left">
      <div class="title-container">
        <a :href="siteData.officialWebsiteLink" target="_blank">
        <h3 class="title" :style="`background:url('${siteData.loginLogo}') no-repeat center /40%`">Login Form
        </h3>
          </a>
        <p>登录</p>
      </div>

      <el-form-item prop="userName">
        <span class="svg-container">
          <svg-icon iconClass="user" />
        </span>
        <el-input ref="username" v-model="loginForm.userName" placeholder="Username" name="username" type="text"
          tabindex="1" auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon iconClass="password" />
        </span>
        <el-input :key="passwordType" ref="password" v-model="loginForm.password" :type="passwordType"
          placeholder="Password" name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :iconClass="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary"
        style="width:100%;margin-bottom:30px;background:#1b51fb;border-color:#1b51fb;"
        @click.native.prevent="handleLogin">
        Login
      </el-button>
      <el-button v-if="siteData.officialWebsiteLink" type="primary" style="width:100%;margin-bottom:30px;background:#1b51fb;border-color:#1b51fb;margin-left: 0;">
      <a href="http://www.jiufanglogistics.cn/" target="_blank">返回官网首页</a></el-button>
      <!-- <div class="tips">
            <span style="margin-right:20px;">username: test01</span>
            <span> password: 123456</span>
          </div> -->
    </el-form>
    <footer class="absolute padding text-center flex align-center justify-center">
      <!-- <span class="margin-right">
        {{siteData.filingNamber}}
      </span> -->
      <span class="margin-right">
        <a target="_blank" href="https://beian.miit.gov.cn" style="text-decoration:none;">
          {{siteData.filingNamber}}
          <!-- 粤ICP备15066393号-1 -->
      </a>
      </span>
      <a target="_blank" href="mailto:ceo@tofba.com" style="text-decoration:none;">
        <img src="../../assets/images/ico_mailme_11.png">
      </a>
    </footer>

    
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
  export default {
    name: 'Login',
    computed: {
      ...mapGetters(['siteData'])
    },
    data() {
      return {
        loginForm: {
          userName: '',
          password: ''
        },
        loginRules: {
          userName: [{
            required: true,
            trigger: 'blur'
          }],
          password: [{
            required: true,
            trigger: 'blur'
          }]
        },
        loading: false,
        passwordType: 'password',
        redirect: undefined,
        swiperList: []
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect
          if(route.query.source=='erp'&& route.query.userName&&route.query.password){
            this.loginForm = {
              userName: route.query.userName,
              password: route.query.password
            }
            this.$nextTick(()=>{
              this.handleLogin()
            })
          }
        },
        immediate: true
      }
    },
    mounted() {
      // this.queryList()
    },
    methods: {
      showPwd() {
        if (this.passwordType === 'password') {
          this.passwordType = ''
        } else {
          this.passwordType = 'password'
        }
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      },
      handleLogin() {
        // console.log('12')
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            if (this.loginForm.password === '123456') {
              sessionStorage.setItem('isSimple', true)
            } else {
              sessionStorage.removeItem('isSimple')
            }
            this.$store
              .dispatch('user/login', this.loginForm)
              .then(async() => {
                console.log('this.redirect', this.redirect)
                this.$router.push({ path: this.redirect || '/' })
                await this.$store.dispatch('user/getInfo')
                await this.$store.dispatch('public/getPublicData')
                this.loading = false
              })
              .catch(err => {
                this.loading = false
              })
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      }
    }
  }

</script>

<style lang="scss">
  /* 修复input 背景不协调 和光标变色 */
  /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

  $bg: #fff;
  $light_gray: #000;
  $cursor: #000;

  @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
      color: $cursor;
    }
  }

  /* reset element-ui css */
  .login-container {
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 47px;
        caret-color: $cursor;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }

    .el-form-item {
      border: 1px solid #ddd;
      background: #fff;
      border-radius: 5px;
      color: #454545;
    }
  }

</style>

<style lang="scss" scoped>
  $bg: #2d3a4b;
  $dark_gray: #889aa4;
  $light_gray: #eee;

  .login-container {
    min-height: 100%;
    width: 100%;
    background: url('../../assets/images/login/login-bg.jpeg') no-repeat center bottom;
    background-size: cover;
    overflow: hidden;

    .login-form {
      position: absolute;
      width: 400px;
      max-width: 100%;
      padding: 20px 40px 40px;
      background-color: #fff;
      margin: 0 auto;
      overflow: hidden;
      top: 50%;
      right: 180px;
      transform: translateY(-50%);
      border-radius: 10px;
      z-index: 111;
    }

    .tips {
      font-size: 14px;
      color: #000;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 0px;
        height: 70px;
        color: $light_gray;
        margin: 0px auto;
        text-align: center;
        font-weight: bold;
        // background: url('../../assets/images/login/login-logo.png') no-repeat center /40%;
      }

      &>p {
        font-size: 18px;
        margin-top: 0;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }

    footer {
      width: 100%;
      bottom: 3%;
      left: 0;
    }
  }

  .contanier {
    position: relative;
  }

</style>
